import { clientWithApiClient } from "../../client";
import type { ApiClient } from "../../types";
import type { ConfigResponse } from "./types";

/**
 * Get fleet configuration (authenticated with API key)
 * @param apiClient - API client configuration with baseUrl and apiKey
 * @returns Promise with configuration data
 */
export function getConfig(apiClient: { baseUrl: string; apiKey: string }) {
  return clientWithApiClient<ConfigResponse>(apiClient, "/config");
}

/**
 * Get the configuration of one fleet (JWT authenticated).
 *
 * `fleet_id` goes in the query string as well as the path: the auth plug
 * resolves the current fleet from `conn.query_params`, so a path segment
 * alone does not scope the request.
 *
 * @param apiClient - API client
 * @param fleetId - Public id of the fleet
 * @returns Promise with configuration data
 */
export function getConfigByFleet(apiClient: ApiClient, fleetId: string) {
  const searchParams = new URLSearchParams();
  searchParams.append("fleet_id", fleetId);

  return clientWithApiClient<ConfigResponse>(
    apiClient,
    `/fleets/${fleetId}/config?${searchParams.toString()}`,
  );
}

/**
 * Get public fleet configuration (authenticated with quote token)
 * @param apiClient - API client configuration with baseUrl and apiKey
 * @param token - Quote access token
 * @returns Promise with configuration data
 */
export function getPublicConfig(
  apiClient: {
    baseUrl: string;
    apiKey: string;
  },
  token: string,
) {
  return clientWithApiClient<ConfigResponse>(
    apiClient,
    `/public/config?token=${token}`,
  );
}
